import { createFileRoute } from "@tanstack/react-router";
import { admitCreator } from "@/features/coworlds/records";
import { CreatorVersion } from "@/features/coworlds";
import { creatorSearch } from "@/features/coworlds/navigation";
import { VerifiedViewer } from "@/session/product-session";

export const Route = createFileRoute("/_site/coworlds/$name/manage")({
  validateSearch: creatorSearch,
  loader: () => admitCreator(),
  component: function ManageCoworldPage() {
    const { name } = Route.useParams();
    const { version } = Route.useSearch();
    const creatorViewer = Route.useLoaderData();
    return (
      <VerifiedViewer viewer={creatorViewer}>
        <CreatorVersion name={name} selectedId={version ?? null} />
      </VerifiedViewer>
    );
  },
});
